"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var context_1 = require("../validator/context");
var ValidationContextRegister = /** @class */ (function (_super) {
    tslib_1.__extends(ValidationContextRegister, _super);
    function ValidationContextRegister() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.setContext = function (newContext) {
            if (newContext === _this.validationContext)
                return null;
            _this.validationContext && _this.validationContext.unregister(_this.props.field);
            if (newContext) {
                _this.validationContext = newContext;
                _this.validationContext.register(_this.props.field);
            }
            return null;
        };
        return _this;
    }
    ValidationContextRegister.prototype.componentWillUnmount = function () {
        this.validationContext && this.validationContext.unregister(this.props.field);
    };
    ValidationContextRegister.prototype.render = function () {
        return (React.createElement(context_1.FieldValidation.Consumer, null, this.setContext));
    };
    return ValidationContextRegister;
}(React.PureComponent));
exports.default = ValidationContextRegister;
//# sourceMappingURL=ValidationContextRegister.js.map